import type {
  AuthenticationResponseJSON,
  PublicKeyCredentialCreationOptionsJSON,
  PublicKeyCredentialRequestOptionsJSON,
  RegistrationResponseJSON,
} from '@simplewebauthn/browser';

export enum MfaMethod {
  Totp = 'totp',
  Passkey = 'passkey',
}

export type MfaCredential = {
  id: string;
  method: MfaMethod;
  name: string | null;
  createdAt: string;
  lastUsedAt: string | null;
  backedUp?: boolean;
  deviceType?: string;
};

export type MfaCredentialsResponse = { credentials: MfaCredential[] };

type MfaEnrollmentBase = {
  interactionToken: string;
  expiresAt: string;
};

export type MfaTotpEnrollment = MfaEnrollmentBase & {
  method: MfaMethod.Totp;
  secret: string;
  otpauthUri: string;
};

export type MfaPasskeyEnrollment = MfaEnrollmentBase & {
  method: MfaMethod.Passkey;
  publicKey: PublicKeyCredentialCreationOptionsJSON;
};

export type MfaEnrollment = MfaTotpEnrollment | MfaPasskeyEnrollment;

export type StartMfaEnrollmentRequest = {
  method: MfaMethod;
  name?: string;
};

export type MfaVerification = {
  interactionToken: string;
  allowedMethods: MfaMethod[];
  expiresAt: string;
  publicKey?: PublicKeyCredentialRequestOptionsJSON;
};

export type MfaVerificationProof =
  | { method: MfaMethod.Totp; interactionToken: string; code: string }
  | {
      method: MfaMethod.Passkey;
      interactionToken: string;
      assertion: AuthenticationResponseJSON;
    };

export type StartPasskeyLoginResponse = {
  interactionToken: string;
  expiresAt: number;
  publicKey: PublicKeyCredentialRequestOptionsJSON;
};

export type ConfirmPasskeyLoginResponse = {
  cognitoUsername: string;
  loginProof: string;
  expiresAt: number;
};

export type { AuthenticationResponseJSON, RegistrationResponseJSON };
